import { useCinematicsStore } from '@/cinematics/stores/CinematicsStore'
import { hasSceneRoute } from '@/cinematics/utils/hasSceneRoute'

export const useHasSceneRoute = (route: string): boolean => {
  const { scenes } = useCinematicsStore()
  return hasSceneRoute(scenes, route)
}
